export const isValidPassword = (
  _password: string,
  _confirmPassword: string,
) => {
  return _password && _confirmPassword && _password === _confirmPassword;
};

export const checkPasswordStrength = (password: string) => {
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()])[A-Za-z\d!@#$%^&*()]{8,}$/;
  return passwordRegex.test(password);
};
